































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";

@Component
class PhoneCodeWindow extends Vue {
  @Prop() title!: string;

  @Prop() method!: string;

  @Prop() phone!: string;

  @Prop() country!: string;

  @State(state => state.basis.account.loginCodeSendTime)
  loginCodeSendTime!: number;

  @Mutation("basis/account/SET_LOGIN_CODE_SEND_TIME") setLoginCodeSend;

  code = "";

  remain = 0;

  interval = 60;

  loading = false;

  codeSending = false;

  timer: any = null;

  get valid() {
    return this.code && this.code.length >= 4;
  }

  get state() {
    const state = this.$route.query.state as string;
    try {
      return JSON.parse(decodeURIComponent(state));
    } catch (error) {
      return "";
    }
  }

  get redirect() {
    return this.state && this.state.redirect;
  }

  @Watch("loginCodeSendTime", { immediate: true })
  handleCodeSendTimeChange() {
    this.setRemainTime();
  }

  setRemainTime() {
    const loginCodeSendTime = this.loginCodeSendTime;
    const now = new Date().getTime();
    const remain = Math.ceil(this.interval - (now - loginCodeSendTime) / 1000);
    if (remain > 0) {
      this.timer = setTimeout(() => {
        this.setRemainTime();
      }, 1000);
      this.remain = remain;
    } else {
      this.remain = 0;
    }
  }

  handleCodeInput() {
    if (this.code.length === 6) {
      this.handleLogin();
    }
  }

  async handleSendCode() {
    this.codeSending = true;
    try {
      await this.$api.account.sendSmsCode({
        phone_code: this.country,
        phone_num: this.phone
      });
      this.setLoginCodeSend(new Date().getTime());
      this.setRemainTime();
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.codeSending = false;
  }

  async handleLogin() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    try {
      const { access_token: token } = await this.$api.account.smsCodeLogin({
        phone_code: this.country,
        phone_num: this.phone,
        code: this.code
      });
      this.$store.commit("auth/SET_TOKEN", { token });
      await this.$store.dispatch("initAccountData");
      this.$common.utils.helper.toast(this, {
        message: this.$t("account.login.success") as string
      });
      this.handleRedirect();
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
    this.loading = false;
  }

  handleRedirect() {
    if (this.redirect) {
      document.location.replace(this.redirect);
    } else {
      this.$helper.toFusionPath(this, "wallet", { name: "index" });
    }
  }

  handleLoginViaMixin() {
    this.$emit("useMixin");
  }
}
export default PhoneCodeWindow;
